import React from 'react';
import './Loading.css';

function Loading(props) {
    return (
        <div className="loader">Loading...</div>
    );
}

export default Loading;